jQuery(function($) {

	$(document).ready(function() {

		const menuToggle = document.querySelector('.menu-toggle');

		menuToggle.onclick = function() {

			document.querySelector('body').classList.toggle('is-menu-open');

		}
		
		var bodyBlackout = $('.body-blackout');

		$('.popup-trigger').on('click', function(e) {
			var popup = $(this).data('popup-trigger');
			triggerPopup(popup);
		});

		function triggerPopup( popup ) {
			var popupModal = $('[data-popup-modal="'+popup+'"]');

			if ( !popupModal.length ) {
				return false;
			}

			popupModal.addClass('is--visible');
			bodyBlackout.addClass('is-blacked-out');
			
			$('.popup-modal__close', popupModal).on('click', function(e) {
			   popupModal.removeClass('is--visible');
			   bodyBlackout.removeClass('is-blacked-out');
			});
			
			bodyBlackout.on('click', function(e) {
			  // TODO: Turn into a function to close modal
			  popupModal.removeClass('is--visible');
			  bodyBlackout.removeClass('is-blacked-out');
			});
		}

		function getHashFilter() {
		  var hash = location.hash;
		  // get filter=filterName
		  var matches = location.hash.match( /modal=([^&]+)/i );
		  var hashFilter = matches && matches[1];
		  return hashFilter && decodeURIComponent( hashFilter );
		}

		var modalHash = getHashFilter();

		if ( modalHash ) {
			triggerPopup( modalHash );
			var sectionAnchor = $('[data-popup-modal="'+modalHash+'"]').data('section-anchor');
			if ( sectionAnchor ) {
				// $('body').scrollTo( '#' . sectionAnchor );
				document.getElementById(sectionAnchor).scrollIntoView();
			}
		}

		const stickyMenu = document.querySelector('#sticky-menu');
		const root = document.documentElement;

		function calcStickyHeight() {
			var stickyHeight = stickyMenu.offsetHeight;
			root.style.setProperty('--sticky-height', stickyHeight + 'px');
		}

		calcStickyHeight();

		window.addEventListener( 'resize', calcStickyHeight );

		// Sessions
		$('.sessions-carousel').each(function (idx, item) {
		   var carouselId = "sessions-carousel-" + idx;
		   this.id = carouselId;
		   var numEvents = $(this).find('.session').length;
		   $(this).slick({
		       slide: "#" + carouselId +" .session",
		       appendArrows: "#" + carouselId + " .slick-nav",
		       infinite: false,
		       slidesToShow: Math.min(3,numEvents),
		       slidesToScroll: 1,
		       prevArrow: '<div class="slick-prev"><i class="fa-solid fa-caret-left"></i></div>',
		       nextArrow: '<div class="slick-next"><i class="fa-solid fa-caret-right"></i></div>',
		       responsive: [
		         {
		           breakpoint: 1050,
		           settings: {
		             slidesToShow: Math.min(2,numEvents)
		           }
		         },
		         {
		           breakpoint: 700,
		           settings: {
		             slidesToShow: Math.min(1,numEvents)
		           }
		         },
		       ]
		   });
		});

		// Speakers
		$('.speakers-carousel').each(function (idx, item) {
		   var carouselId = "speakers-carousel-" + idx;
		   this.id = carouselId;
		   var numSpeakers = $(this).find('.speaker').length;
		   $(this).slick({
		       slide: "#" + carouselId +" .speaker",
		       appendArrows: "#" + carouselId + " .slick-nav",
		       infinite: false,
		       slidesToShow: Math.min(5,numSpeakers),
		       slidesToScroll: 1,
		       prevArrow: '<div class="slick-prev"><i class="fa-solid fa-caret-left"></i></div>',
		       nextArrow: '<div class="slick-next"><i class="fa-solid fa-caret-right"></i></div>',
		       responsive: [
		         {
		           breakpoint: 1250,
		           settings: {
		             slidesToShow: Math.min(4,numSpeakers)
		           }
		         },
		         {
		           breakpoint: 1000,
		           settings: {
		             slidesToShow: Math.min(3,numSpeakers)
		           }
		         },
		         {
		           breakpoint: 750,
		           settings: {
		             slidesToShow: Math.min(2,numSpeakers)
		           }
		         },
		         {
		           breakpoint: 500,
		           settings: {
		             slidesToShow: Math.min(1,numSpeakers)
		           }
		         }
		       ]
		   });
		});

		// Presentations
		$('.presentation-tabs a').on('click', function(e) {
			e.preventDefault();
			if ( $(this).hasClass('active') ) {
				return false;
			}
			$('.presentation-tabs a').removeClass('active');
			$(this).addClass('active');

			$('.presentation-content .sessions').removeClass('active');
			$( $(this).attr('href') ).addClass('active');
		});

		// Gallery Carousel
		if ( $('.photo-gallery-carousel').length ) {
			$('.photo-gallery-carousel').on('init', function(event, slick){
			  slick.$slider.css('--slide-max-width', slick.$slider.innerWidth() + 'px' );
			  $( window ).resize( function() {
			  	slick.$slider.css('--slide-max-width', slick.$slider.innerWidth() + 'px' );
			  });
			});
			$('.photo-gallery-carousel').slick({
			  dots: true,
			  infinite: true,
			  swipeToSlide: true,
			  variableWidth: true,
			  centerMode: true,
			  slide: '.slide',
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-angle-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-angle-right"></i></div>'
			});
		}

		var tabbedCarousels = $('.gna-tabbed-carousel');

		if ( tabbedCarousels.length ) {
			$('.carousel-tabs li', tabbedCarousels ).click( function(e) {
				e.preventDefault();
				if ( $(this).hasClass('active') ) return false;
				var carouselID = $(this).data('carousel-id');
				$('.carousel-tabs li', tabbedCarousels ).removeClass('active');
				$(this).addClass('active');
				$('.carousel', tabbedCarousels).removeClass('active');
				$('#'+carouselID).addClass('active');
			});
			$('.carousel', tabbedCarousels).each( function() {
				$(this).slick({
				  dots: true,
				  infinite: true,
				  swipeToSlide: true,
				  variableWidth: true,
				  centerMode: true,
				  slide: '.slide',
				  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-angle-left"></i></div>',
				  nextArrow: '<div class="slick-next"><i class="fa-solid fa-angle-right"></i></div>'
				});
			});
		}

		var sponsorsShowMore = $('.cahls-sponsors-show-more');

		if ( sponsorsShowMore.length ) {
			$('.show-more-toggle button', sponsorsShowMore).click( function(e) {
				e.preventDefault();
				sponsorsShowMore.addClass('open');
			});
		}

		$('.gna-quote-carousel .carousel').slick({
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    arrows: false,
		    dots: true,
		    autoplay: true,
		    autoplaySpeed: 10000
		});



		// $('.cahls-register-types .more-toggle').click( function(e) {
		// 	$(this).parents('.register-block').toggleClass('open');
		// });

		// $('[data-target]').click( function(e) { console.log('data target clicks');
		// 	e.preventDefault();
		// 	var target = $(this).data('target')
		// 	console.log(target);
		// 	$('#' + target).toggleClass('visible');
		// });

		// $('.popup .close, .popup-background').click( function(e) {
		// 	e.preventDefault();
		// 	$('.popup').removeClass('visible');
		// });
	});
});